<template>
  <event-row-skeleton v-if="status === 'loading'" :action="props.event.action" />

  <div
    v-if="status === 'success'"
    :class="['szw-row szw-w-full szw-gap-2 szw-p-2', { 'szw-border-b szw-border-border last:szw-border-b-0': props.event.action !== 'period-info' }]"
  >
    <template v-if="props.event.action !== 'period-info'">
      <div class="szw-row__center szw-w-12 szw-h-5">
        <span class="szw-text-center szw-font-semibold szw-text-xs">{{ props.event.minute }}</span>
      </div>

      <img v-if="props.team.logo" class="szw-h-5 szw-w-5" :src="props.team.logo" alt="logo" />
      <fallback-logo v-else :text="props.team.shortName" />

      <div class="szw-col szw-mr-auto">
        <span class="szw-font-semibold szw-text-xs">{{ props.event.label }}</span>
        <span class="szw-uppercase szw-text-xxs">{{ props.event.personName }}</span>
      </div>

      <div v-if="props.event.svgId" class="szw-row__center szw-h-5 szw-w-5">
        <sprite :sprite-id="props.event.svgId" />
      </div>
    </template>
    <template v-else>
      <span class="szw-text-text-icon-tertiary szw-text-xxs szw-uppercase szw-font-semibold">{{ props.event.kind }}</span>
    </template>
  </div>
</template>

<script setup>
import FallbackLogo from '@/__core__/components/FallbackLogo.vue'
import Sprite from '@/__core__/components/sprite/Sprite.vue'
import EventRowSkeleton from './EventRowSkeleton.vue'
import { inject } from 'vue'

const props = defineProps({
  event: {
    type: Object,
    default: () => ({})
  },
  team: {
    type: Object,
    default: () => ({})
  }
})

const status = inject('status')
</script>
